/*
  ------------------------------------------------------------------------------
  Loads external script file

  @param {String} src The path of the file
  @param {Bool} cache Cache or bust the cache
*/
var loadScript = function loadScript(src) {
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return new Promise(function (resolve, reject) {
    if (!cache) {
      var time = new Date().getTime();
      src = "".concat(src).concat(src.includes("?") ? "&" : "?", "cachebust").concat(time, "=").concat(time);
    }

    var script = document.createElement("script");
    script.addEventListener("load", resolve);
    script.addEventListener("error", function () {
      return reject(new Error("Error loading script"));
    });
    script.addEventListener("abort", function () {
      return reject(new Error("Script loading aborted"));
    });
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  });
};
/*
  ------------------------------------------------------------------------------
*/


export default loadScript;